var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticStyle:{"margin-bottom":"1.5%"},attrs:{"id":'socialSecurityStatus_'+_vm.appointmentId,"reduce":s => s.id,"label":"name","options":_vm.socialSecurityStatusList},model:{value:(_vm.selectedSocialSecurityStatus),callback:function ($$v) {_vm.selectedSocialSecurityStatus=$$v},expression:"selectedSocialSecurityStatus"}})
}
var staticRenderFns = []

export { render, staticRenderFns }